module.exports = __webpack_public_path__ + "images/background/image/5-8d0b896be8327eedd37f85aa426abc08.jpg";